import React, { useState, useEffect } from "react";
import Image from "../../assets/img/ShiproneLogo.png";
import ComponentList from "./Components/ComponentList";
import ComponentSetting from "./Components/ComponentSetting";
import ComponentPreview from "./Components/ComponentPreview";
import CreateComponentModel from "./Components/CreateComponentModel";
import DownloadComponentModal from "./Components/DownloadComponentModal";
import { getAllComponentList } from "../../redux/actions/manageComponent";
import swal from "@sweetalert/with-react";
import { useDispatch, useSelector } from "react-redux";
import CustomeModal from "../../component/modal-popup/customeModal";
import BackButtonWindow from "../../component/Alert/BackButtonWindow";
import { useLocation } from "react-router-dom";

function ComponentIndex() {
  const dispatch = useDispatch();
  const { tempPageName, path } = useSelector((state) => state.tempWindowsData);

  const location = useLocation();
  const { state } = location;

  const [showWatermark, setShowWatermark] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [downloadComponentModalOpen, setDownloadComponentModalOpen] =
    useState(false);
  const [update, setUpdate] = useState(0);

  // Creating states for basic configurations.
  const [componentParameter, setComponentParameter] = useState({
    componentType: "",
    componentId: "",
    componentName: "",
    componentPlaceholder: "",
    componentTooltip: "",
    isCheckedByDefault: false,
    validation: [],
    minimumValue: "",
    maximumValue: "",
    component_special_id: "",
    priorDate: true,
    futureDate: true,
    link_url: "",
    previewValue: ""
  });

  const [dropdownOptions, setDropdownOptions] = useState([
    { label: null, value: null },
  ]);

  const getComponentListData = () => {
    const request = {
      onError: () => {
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content="Unable to fetch component list"
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };
    dispatch(getAllComponentList(request));
  };

  // Integrating API to get all component list
  useEffect(() => {
    getComponentListData();
  }, [update]);

  return (
    <>
      {path !== "" && tempPageName !== "" && (
        <BackButtonWindow
          backButtonName={tempPageName}
          title="Completed creating booking template?"
          path={path}
          state={state}
        />
      )}
      <div
        className="mt-4 sm:mx-6 lg:mx-8 h-screen space-x-4 flex"
        style={{ maxHeight: "calc(100vh - 107px)" }}
      >
        <div className="w-1/4">
          <ComponentList
            setModalOpen={setModalOpen}
            componentParameter={componentParameter}
            setDropdownOptions={setDropdownOptions}
            setComponentParameter={setComponentParameter}
            setShowWatermark={setShowWatermark}
            downloadComponentModalOpen={downloadComponentModalOpen}
            setDownloadComponentModalOpen={setDownloadComponentModalOpen}
          />
        </div>

        <div className="w-3/4">
          <div className="flex space-x-4">
            <div className="w-[63%]">
              <h4 className="text-sm leading-3 tracking-tight font-bold text-[#535860] pb-1 border-b border-[#D9D9D9]">
                Settings
              </h4>
              {!showWatermark && (
                <ComponentSetting
                  update={update}
                  setUpdate={setUpdate}
                  showWatermark={showWatermark}
                  setShowWatermark={setShowWatermark}
                  componentParameter={componentParameter}
                  setComponentParameter={setComponentParameter}
                  dropdownOptions={dropdownOptions}
                  setDropdownOptions={setDropdownOptions}
                />
              )}
            </div>
            <div className="w-[37%]">
              <h4 className="text-sm leading-3 tracking-tight font-bold text-[#535860] pb-1 border-b border-[#D9D9D9]">
                Preview
              </h4>
              {!showWatermark && (
                <ComponentPreview
                  componentParameter={componentParameter}
                  dropdownOptions={dropdownOptions}
                  setShowWatermark={setShowWatermark}
                  setComponentParameter={setComponentParameter}
                />
              )}
            </div>
          </div>
          {showWatermark && (
            <div
              className="h-screen flex justify-center items-center"
              style={{ maxHeight: "calc(100vh - 135px)" }}
            >
              <div
                className="w-2/3 h-2/3 bg-center bg-opacity-25 flex justify-center items-center"
                style={{
                  backgroundImage:
                    "linear-gradient(rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)), url(" +
                    Image +
                    ")",
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                }}
              >
                <div className="text-center">
                  <h4 className="text-[15px] leading-7 tracking-tight font-bold text-[#1E293B] ">
                    Select a Component
                  </h4>
                  <p className="text-[15px] leading-7 tracking-tight text-[#1E293B]">
                    or Create a New Component
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* ------------ Create Component modal pop-up ------------- */}
        <CreateComponentModel
          modalOpen={modalOpen}
          setModalOpen={setModalOpen}
          setShowWatermark={setShowWatermark}
          componentParameter={componentParameter}
          setComponentParameter={setComponentParameter}
        />
        {/* Download Component Modal pop-up */}
        <DownloadComponentModal
          modalOpen={downloadComponentModalOpen}
          setModalOpen={setDownloadComponentModalOpen}
        />
      </div>
    </>
  );
}

ComponentIndex.auth = {
  path: "/component/create",
  role: "super-admin admin",
};

export default ComponentIndex;
